const axios = require("axios");

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import { functionAppURL, getAzToken } from "../../config/azToken";

const CostEstimationCard: view = ({
  getUploadStatus = observe.costEstUploadStatus,
  setUploadStatus = update.costEstUploadStatus,
  pca = get.pca,
}) => {
  const currentAccount = pca.value().getAllAccounts()[0];
  const { email: userEmail } = currentAccount.idTokenClaims;

  const payload = (data: any) => {
    return {
      method: "post",
      url: `${functionAppURL}/route/costEst`,
      params: { code: getAzToken() },
      headers: {
        "Content-Type": "multipart/form-data",
        From: userEmail,
      },
      data,
      responseType: "json",
    };
  };

  const handleChange = async (e: any) => {
    const files = e.target.files;
    const formData = new FormData();
    Object.keys(files).map((key: any) => {
      const file = files[key] || {};
      formData.append(`file_${key}`, file, file.name);
    });

    setUploadStatus.set("In Progress");
    const { message } = (await axios(payload(formData))).data;
    message === "files uploaded"
      ? setUploadStatus.set("Done")
      : "cost estimation in progress"
      ? setUploadStatus.set("Already in progress")
      : setUploadStatus.set("Failed");
  };

  return (
    <Card sx={{ maxHeight: 300, maxWidth: 270 }}>
      <CardContent>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
          Cost Estimation Activity
        </Typography>
        <Typography variant="h4" component="div">
          Start Cost Estimation
        </Typography>
        {/* <Typography sx={{ mb: 3.5 }} color="text.secondary">
          Run
        </Typography> */}
        <Typography variant="body1">
          On this card you can upload Revit files to start a cost estimation
        </Typography>
        <Typography
          variant="h6"
          color={
            getUploadStatus === "Done"
              ? "green"
              : getUploadStatus === ""
              ? "text.secondary"
              : getUploadStatus === "In Progress"
              ? "blue"
              : "red"
          }
        >
          {!getUploadStatus ? "Status" : getUploadStatus}
        </Typography>
        <br />
        <Button variant="contained" component="label">
          Upload
          <form>
            <input
              hidden
              accept=".csv"
              multiple
              type="file"
              onClick={(e: any) => (e.target.value = "")}
              onChange={handleChange}
            />
          </form>
        </Button>
      </CardContent>
    </Card>
  );
};

export default CostEstimationCard;
